/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ListScriptsResponse } from '../models/ListScriptsResponse';
import type { Script } from '../models/Script';
import type { ScriptForm } from '../models/ScriptForm';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ScriptRestControllerService {
    /**
     * @returns ListScriptsResponse OK
     * @throws ApiError
     */
    public static listScripts({
        creatorId,
    }: {
        creatorId: number,
    }): CancelablePromise<ListScriptsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/settings/scripts',
            query: {
                'creatorId': creatorId,
            },
        });
    }
    /**
     * @returns Script OK
     * @throws ApiError
     */
    public static editScript({
        creatorId,
        id,
        requestBody,
    }: {
        creatorId: number,
        id: number,
        requestBody: ScriptForm,
    }): CancelablePromise<Script> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/dashboard/api/v1/settings/scripts',
            query: {
                'creatorId': creatorId,
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns Script OK
     * @throws ApiError
     */
    public static addScript({
        creatorId,
        requestBody,
    }: {
        creatorId: number,
        requestBody: ScriptForm,
    }): CancelablePromise<Script> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/settings/scripts',
            query: {
                'creatorId': creatorId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static removeScript({
        creatorId,
        id,
    }: {
        creatorId: number,
        id: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/dashboard/api/v1/settings/scripts',
            query: {
                'creatorId': creatorId,
                'id': id,
            },
        });
    }
    /**
     * @returns Script OK
     * @throws ApiError
     */
    public static apiOrderScripts({
        creatorId,
        requestBody,
    }: {
        creatorId: number,
        requestBody: Record<string, any>,
    }): CancelablePromise<Array<Script>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/settings/scripts/order',
            query: {
                'creatorId': creatorId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns Script OK
     * @throws ApiError
     */
    public static moveScript({
        creatorId,
        id,
        requestBody,
    }: {
        creatorId: number,
        id: number,
        requestBody: Record<string, Array<number>>,
    }): CancelablePromise<Array<Script>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/settings/scripts/move',
            query: {
                'creatorId': creatorId,
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns Script OK
     * @throws ApiError
     */
    public static findScript({
        creatorId,
        scriptId,
    }: {
        creatorId: number,
        scriptId: number,
    }): CancelablePromise<Script> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/settings/scripts/{scriptId}',
            path: {
                'scriptId': scriptId,
            },
            query: {
                'creatorId': creatorId,
            },
        });
    }
    /**
     * @returns number OK
     * @throws ApiError
     */
    public static getSentScriptIds({
        creatorId,
        fanId,
    }: {
        creatorId: number,
        fanId: number,
    }): CancelablePromise<Array<number>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/settings/scripts/creators/{creatorId}/fans/{fanId}',
            path: {
                'creatorId': creatorId,
                'fanId': fanId,
            },
        });
    }
}
